const getLocalitySuburb = (locations, suburb, state, postcode) => {
  const [mainLocation] = locations || [];
  const { address } = mainLocation || {};
  const {
    display_suburb: displaySuburb,
    display_suburb_valid: displayValid,
    display_suburb_empty: displayEmpty,
    display_suburb_state: displayState,
    display_suburb_postcode: displayPostcode,
  } = address || {};

  if (displaySuburb && displayValid && !displayEmpty) {
    return {
      localitySuburb: displaySuburb,
      localityState: displayState,
      localityPostcode: displayPostcode,
    };
  }

  return {
    localitySuburb: suburb,
    localityState: state,
    localityPostcode: postcode,
  };
};

export default getLocalitySuburb;
